import { Component, OnDestroy, } from '@angular/core';
import { Subscription } from 'rxjs';
import { SettingsBreadCrumbService, BreadCrumbOptions } from '../settings-breadcrumb.service';
import { IdsForSettingsService } from '../ids-for-settings.service';
import { PermissionsApiClient } from 'src/app/services/api-clients/permissions.apiclient';
import { PermissionModel } from 'src/app/models/api/permission.model';
import { PermissionGroup } from 'src/app/constants/settings.enum';
import { SettingsBasePermissionsPage } from './settings-base-permissions.page';
import { LevelEnum } from 'src/app/constants/level.enum';
import { PermissionsService } from '../permissions.service';
@Component({
  templateUrl: './settings-base-permissions.page.html'
})
export class SettingsWhitelabelPermissionsPage extends SettingsBasePermissionsPage implements OnDestroy {
  whitelabelIdSubscription: Subscription;
  selectedWhitelabelId: string = "";
  level: LevelEnum = LevelEnum.WhitelabelLevel;

  constructor(protected override permissionsApiClient: PermissionsApiClient,
    protected override settingsBreadCrumbService: SettingsBreadCrumbService,
    protected override idsForSettingsService: IdsForSettingsService,
    protected override permissionsService: PermissionsService) {

    super(permissionsApiClient, settingsBreadCrumbService, idsForSettingsService, permissionsService);

    this.whitelabelIdSubscription = this.idsForSettingsService.selectedWhiteLabelId$.subscribe(whitelabelId => {
      if (!whitelabelId || whitelabelId === this.selectedWhitelabelId) return;
      this.selectedWhitelabelId = whitelabelId;
      
      // setup specialised breadcrumb
      this.settingsBreadCrumbService.SetWhiteLabelCrumbs(BreadCrumbOptions.Whitelabel_Permissions(this.selectedWhitelabelId))
      this.getPermissions();
      this.permissionsService.refreshForWhitelabel(this.selectedWhitelabelId);
    });
  }

  ngOnDestroy(): void {
      if (this.whitelabelIdSubscription) {
          this.whitelabelIdSubscription.unsubscribe();
      }
  }

  getPermissions() {
    this.permissionsApiClient.getWhitelabelPermissions(this.selectedWhitelabelId).subscribe({
      next: (permissionsData: PermissionModel[]) => {
        this.permissions = permissionsData.filter(permission => permission.configurationGroup != PermissionGroup.Setting);
      }
    })
  }
}